import { ReactNode, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { getCookie } from "src/shared/api/helpers";
import { useGetPermissionsQuery } from "src/shared/api/rbac/rbac";
import { setUserAuthentication } from "src/shared/lib/store/slices/auth";
import {
  useTypedDispatch,
  useTypedSelector,
} from "../../shared/lib/store/store";

export const PrivateRoute = ({
  children = <Outlet />,
}: {
  children?: ReactNode;
}) => {
  const dispatch = useTypedDispatch();
  const isUserAuthenticated = useTypedSelector(
    (state) => state.auth.isUserAuthentication,
  );

  const sessionId = getCookie("PHPSESSID");

  const { isLoading, isError, error, isSuccess } = useGetPermissionsQuery(
    undefined,
    { skip: !sessionId },
  );

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!sessionId) {
      window.location.href = "/auth/signin";

      return;
    }

    if (isSuccess && !isUserAuthenticated) {
      dispatch(setUserAuthentication(true));
      setChecked(true);

      return;
    }

    if (isError) {
      dispatch(setUserAuthentication(false));
      setChecked(true);

      return;
    }

    if (isUserAuthenticated && !checked) {
      setChecked(true);
    }
  }, [sessionId, isSuccess, isError, isUserAuthenticated, dispatch, checked]);

  useEffect(() => {
    if (!checked) return;

    const pathname = window.location.pathname;

    if (error && "status" in error && error.status === 403) {
      if (pathname !== "/403") {
        window.location.href = "/403";
      }

      return;
    }

    if (!isUserAuthenticated && pathname !== "/auth/signin") {
      window.location.href = "/auth/signin";

      return;
    }

    if (isUserAuthenticated && pathname === "/auth/signin") {
      window.location.href = "/v2/partners";
    }
  }, [checked, error, isUserAuthenticated]);

  if (!checked || isLoading) {
    return null;
  }

  return <>{children}</>;
};
